import Headspace from 'headspace';

(function ($) {
    /* Custom JS
	   Feel free to break into separate files if individual functions grow to excessive sizes.
	   Gulp will concatenate and minify separate files automatically.
	*/

    Headspace(document.getElementById('header'), {
        tolerance: 8, // default: 8
        showAtBottom: true,
    });

    $(document).on('facetwp-loaded', function () {
        $('.facetwp-facet').each(function () {
            var $facet = $(this);
            var facet_name = $facet.attr('data-name');
            var facet_label = FWP.settings.labels[facet_name];

            if ($facet.closest('.facet-wrap').length < 1) {
                $facet.wrap('<div class="facet-wrap"></div>');
                $facet.before(
                    '<h5 class="facet-label">' + facet_label + '</h5>'
                );
            }
        });
    });

    $(document).on('facetwp-refresh', function () {
        $('.facetwp-template').animate({ opacity: 0 }, 500);
    });

    $(document).on('facetwp-loaded', function () {
        $('.facetwp-template').animate({ opacity: 1 }, 500);

        let $job = $('.matador-job-listings');
        // Check LocalStorage to see if we've already visited a job, if not, append the "new" badge.
        $.each($job, function () {
            let $jobid = $(this).find('a').data('jobid');
            let $storedJobid = window.localStorage.getItem($jobid);
            if ('true' != $storedJobid) {
                $(this)
                    .find('.entry-header')
                    .append(
                        '<span class="badge badge-pill badge-secondary text-white mb-2">new</span>'
                    );
            }
        });

        // Store visited jobs in LocalStorage.
        $('.matador-job-listings a').on('click', function () {
            let $jobid = $(this).data('jobid');
            window.localStorage.setItem($jobid, 'true');
        });
    });

    $('.enable-list-view').on('click', function (e) {
        e.preventDefault();
        $('.view-toggle').removeClass('active');
        $(this)
            .addClass('active')
            .parents()
            .find('#resource-results')
            .removeClass('grid-view')
            .addClass('list-view');
    });

    $('.enable-grid-view').on('click', function (e) {
        e.preventDefault();
        $('.view-toggle').removeClass('active');
        $(this)
            .addClass('active')
            .parents()
            .find('#resource-results')
            .removeClass('list-view')
            .addClass('grid-view');
    });
})(jQuery);



// WEBPACK FOOTER //
// ./src/js/scripts.js